import RenderHTML from '@/components/RenderHTML/RenderHTML';

import { Props } from './types';

const RenderRichText = ({ body, className }: Props) => {
  return <RenderHTML className={className} html={body ?? ''} />;
};

export default RenderRichText;
